// The rating scale every Benchmark Analysis section draws against. Most orgs
// rate on 1–6, some (configured by org ID on the backend) on 1–4; each
// visualization response says which via `scaleType`, which the reducer keeps
// as BenchmarkFilteringReducer.scaleType.
//
// The configs are static objects, so getScaleConfig hands back the same
// reference for the same scale and a connected component reading it through
// mapStateToProps doesn't re-render for nothing.
export const SCALE_TYPES = {
    SIX_POINT: 'SIX_POINT',
    FOUR_POINT: 'FOUR_POINT',
};

const SCALE_CONFIGS = {
    [SCALE_TYPES.SIX_POINT]: {
        type: SCALE_TYPES.SIX_POINT,
        points: 6,
        min: 1,
        max: 6,
        // Scores at or above this count as "favorable".
        favorableThreshold: 4,
    },
    [SCALE_TYPES.FOUR_POINT]: {
        type: SCALE_TYPES.FOUR_POINT,
        points: 4,
        min: 1,
        max: 4,
        // 3–4 are favorable (strengths), 1–2 are improvement areas.
        favorableThreshold: 3,
    },
};

// Anything other than a known scale — including no response yet, or a
// response that left `scaleType` out — reads as the 6-point scale.
export const getScaleConfig = (scaleType) => SCALE_CONFIGS[scaleType] || SCALE_CONFIGS[SCALE_TYPES.SIX_POINT];

// Every whole score on the scale, low to high: [1, 2, 3, 4] or [1, ..., 6].
export const scaleScores = (scale) => Array.from(
    { length: scale.max - scale.min + 1 },
    (_, i) => scale.min + i
);
